import React from 'react';

const roles = [
  { period: 'DEC 2024 — PRESENT', role: 'Software Developer', company: 'Spring Time Software Solutions', place: 'Noida', bullets: [
    'Developing modern React and Next.js applications for a B2B platform using SSR, lazy loading, and code splitting.',
    'Architected a shared component library that cut development time for new features by approximately 30%.',
    'Built REST and GraphQL services with Node.js and ASP.NET Web API, including validation, structured errors, Swagger docs, and real-time webhooks.'
  ]},
  { period: 'OCT 2022 — NOV 2024', role: 'MERN Developer', company: 'Advance Digital Solutions Pvt. Ltd.', place: 'Mumbai', bullets: [
    'Built and maintained three production web applications serving active end users across React, Next.js, Node.js, Express, and MongoDB.',
    'Migrated critical pages to Next.js SSR and dynamic imports, improving average load time by approximately 20%.',
    'Integrated Razorpay, OAuth, logistics APIs, and resolved three production-blocking vendor integration issues.'
  ]}
];

export default function Experience() {
  return <section className="section experience" id="Experience">
    <div className="section__head"><span className="section__number">02</span><p className="eyebrow">EXPERIENCE</p><h2>Building, measuring, improving.</h2></div>
    <div className="timeline">{roles.map((r, i) => <article className="timeline__item" key={r.company}>
      <div className="timeline__meta"><span>{r.period}</span><small>{r.place}, India</small></div>
      <div className="timeline__body"><span className="timeline__index">0{i + 1}</span><h3>{r.role}</h3><h4>{r.company}</h4><ul>{r.bullets.map(b => <li key={b}>{b}</li>)}</ul></div>
    </article>)}</div>
  </section>;
}
